import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'To confirm your payment, log in to {providerName}.',
    id: 'AwaitingThirdpartyAuthenticationPay.Title',
  },
  titleApp: {
    defaultMessage: 'Approve the payment with the {providerAppName} app',
    id: 'AwaitingThirdpartyAuthenticationPay.TitleApp',
  },
  titleSign: {
    defaultMessage: 'Sign payment with {providerName}.',
    id: 'AwaitingThirdpartyAuthenticationPay.TitleSign',
  },
  step2: {
    defaultMessage: 'You will be required to log in and confirm the payment.',
    id: 'AwaitingThirdpartyAuthenticationPay.step2',
  },
  step3: {
    defaultMessage: 'Once the payment is confirmed, you will be redirected back to {clientName}.',
    id: 'AwaitingThirdpartyAuthenticationPay.step3',
  },
});
